import { render, staticRenderFns } from "./SiteNew.vue?vue&type=template&id=efff96a6&"
import script from "./SiteNew.vue?vue&type=script&lang=js&"
export * from "./SiteNew.vue?vue&type=script&lang=js&"
import style0 from "./SiteNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports